import DriverInvitation from "features/companies/drivers/invitation/components/DriverInvitation";

export const DriverInvitationPage = () => <DriverInvitation />;
